// Central source of truth for app store URLs
export const APP_STORE_URL = 'https://apps.apple.com/gb/app/game2earn/id6788745638';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.game2earn&hl=en_GB';

// Returns 'ios' | 'android' | null based on the visiting device's user agent
export const detectMobilePlatform = () => {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || navigator.vendor || '';

  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return null;
};
